import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'card', 'content']

  toggle(event) {
    const enabled = event.target.checked

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = enabled ? 'Enabled' : 'Disabled'
    }

    if (this.hasCardTarget) {
      this.cardTarget.classList.toggle('opacity-50', !enabled)
    }

    // Toggle opacity on all content targets
    this.contentTargets.forEach(content => {
      content.classList.toggle('opacity-50', !enabled)
    })
  }
}
